<ng-container [formGroup]="form">
  @for (
    group of form.controls.valueIdAllocations.controls;
    track $index;
    let i = $index, first = $first, last = $last, count = $count
  ) {
    <ng-container [formGroup]="group">
      <app-form-control margin="small" [columnLayout]="true">
        <div class="row flex-grow-1">
          <div class="col vertical mb-0">
            <div class="row gx-2 mb-0">
              <div class="col col-8" appValidationContext>
                @if (first) {
                  <app-form-label>
                    {{ field.name }}
                  </app-form-label>
                }

                <select
                  appFormControl
                  formControlName="valueId"
                  (ngModelChange)="onAllocationChange()"
                >
                  @if (last) {
                    <option value="">
                      {{ first ? '&ndash;' : 'Unassigned' }}
                    </option>
                  }
                  @for (fieldValue of field.values; track fieldValue) {
                    <option
                      [ngValue]="fieldValue.id"
                      [disabled]="isDisabledValue(i, fieldValue)"
                    >
                      {{ fieldValue.value }}
                      @if (
                        fieldValue.classificationValueMapping?.value;
                        as value
                      ) {
                        ({{ value }})
                      }
                    </option>
                  }
                </select>
                <div *invalidMessageFor="'required'">Value is required</div>
              </div>

              @if (count > 1 || group.controls.valueId.value) {
                <div class="col col-3">
                  @if (first) {
                    <app-form-label> Allocation </app-form-label>
                  }
                  <app-percentage-input
                    formControlName="allocation"
                    (ngModelChange)="onAllocationChange()"
                    [readOnly]="last && !first && !group.controls.valueId.value"
                  >
                    @if (group.controls.allocation.hasError('required')) {
                      <div class="invalid-feedback">Allocation is required</div>
                    }
                    @if (group.controls.allocation.getError('min'); as error) {
                      <div class="invalid-feedback">
                        Allocation must be at least {{ error.min | aapercent }}
                      </div>
                    }
                    @if (group.controls.allocation.getError('max'); as error) {
                      <div class="invalid-feedback">
                        Allocation must be at most {{ error.max | aapercent }}
                      </div>
                    }
                  </app-percentage-input>
                </div>
              }

              @if (count > 1) {
                <div class="col col-1">
                  <div>
                    @if (first) {
                      <app-form-label class="d-block">&nbsp;</app-form-label>
                    }
                    <button
                      type="button"
                      class="btn btn-danger-outline"
                      aria-label="Remove"
                      [disabled]="
                        (first && last) ||
                        (last && !group.controls.valueId.value)
                      "
                      (click)="remove(i)"
                    >
                      <i-lucide name="trash2"></i-lucide>
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </app-form-control>
    </ng-container>
  }

  @if (form.getError('minDate'); as error) {
    <app-form-control [columnLayout]="true">
      <div class="text-danger">
        Date must be on or after {{ error.minDate | aadate }} for
        {{ field.name }}
      </div>
    </app-form-control>
  }
</ng-container>
